export const ROLES_WITH_PERMISSIONS = [
  {
    key: "administrator",
    value: "Administrator",
    childrens: [],
  },
  {
    key: "user_management",
    value: "User Management",
    childrens: [
      { key: "add_system_user", value: "Add User" },
      { key: "edit_system_user", value: "Edit User" },
      { key: "delete_system_user", value: "Delete User" },
      {
        key: "active/inactive_system_user",
        value: "Active/InActive System User",
      },
      {
        key: "login_to_customer_dashboard",
        value: "Login To Customer Dashboard",
      },
    ],
  },
  {
    key: "roles_management",
    value: "Roles Management",
    childrens: [
      { key: "add_role", value: "Add Role" },
      { key: "edit_role", value: "Edit Role" },
      { key: "delete_role", value: "Delete Role" },
      {
        key: "active/inactive_system_role",
        value: "Active/InActive System Role",
      },
    ],
  },
  {
    key: "activity_logs",
    value: "Activity Logs",
    childrens: [{ key: "view_activity_logs", value: "View Activity Logs" }],
  },
  {
    key: "customer_management",
    value: "Customer Management",
    childrens: [
      { key: "edit_customer", value: "Edit Customer" },
      { key: "delete_customer", value: "Delete Customer" },
      { key: "approve/reject_customer", value: "Approve/Reject Customer" },
      { key: "active/inactive_customer", value: "Active/Inactive Customer" },
    ],
  },
  {
    key: "deposit",
    value: "Deposit",
    childrens: [{ key: "confirm_deposit", value: "Confirm Deposit" }],
  },
  {
    key: "withdrawal",
    value: "Withdrawal",
    childrens: [{ key: "confirm_withdrawal", value: "Confirm Withdrawal" }],
  },
];

export const PERMISSIONS = ROLES_WITH_PERMISSIONS.reduce(
  (acc, curr) => {
    acc = [...acc, ...curr.childrens];
    return acc;
  }
  , [] as any[]
);

export const getShortenAddress = (address: string) => address.substring(0, 6) + "..." + address.substring(address.length - 4);
